import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '../../lib/utils';
import { surfaceVariants } from './variants';

type SurfaceProps = ComponentProps<'div'> &
  VariantProps<typeof surfaceVariants>;

/**
 * The base surface primitive — a neutral, rounded, bordered panel. Card and
 * Box build on the same base (via `SURFACE_BASE`); use `Surface` directly when
 * a plain padded panel is all that's needed.
 */
function Surface({ className, padding, shadow, ...props }: SurfaceProps) {
  return (
    <div
      data-slot={'surface'}
      className={cn(surfaceVariants({ padding, shadow }), className)}
      {...props}
    />
  );
}

export { Surface };
export type { SurfaceProps };
